/**
 * Build Azure Blob SAS URL from a blob filename
 * Matches the ERP frontend pattern for constructing signed URLs
 */
const buildBlobUrl = (blobName) => {
  if (!blobName) return '';
  if (blobName.startsWith('http')) return blobName;
  const baseUrl = process.env.REACT_APP_AZURE_BLOB_URL;
  const container = process.env.REACT_APP_AZURE_BLOB_CONTAINER;
  const sasToken = process.env.REACT_APP_AZURE_BLOB_SAS_TOKEN;
  if (!baseUrl || !container) return '';
  const url = `${baseUrl}/${container}/${blobName}`;
  return sasToken ? `${url}?${sasToken}` : url;
};

export default buildBlobUrl;
